<template>
    <li :class="{active: (media.id == viewMedia.id)}">
        <a href="#//" @click="selectedMediaOpenMethod(media)">
            <div class="thumb">
                <img
                    :src="media.thumbnail"
                    :alt="media.title+' 이미지 입니다.'"
                >
                <span class="source-origin" v-show="media.copyright!='한국문화원연합회'">사진출처: {{media.copyright}}</span>
            </div>
            <div class="data-wrap">
                <strong class="title">{{media.title}}</strong>
                <ul class="asset-data-meta">
                    <li v-if="media.child_theme_name">{{ media.theme_name }} &gt; {{ media.child_theme_name }}</li>
                    <li class="bar">{{media.major_category_name}} &gt; {{media.minor_category_name}}</li>
                </ul>
                <p class="list-info" v-show="media.copyright!='한국문화원연합회'">{{media.copyright}}</p>
            </div>
        </a>
    </li>
</template>

<script>
// [TODO] 혹시 funtional 로 가능하면...
export default {
    props: {
        media: { type: Object }, // 미디어 정보 객체
        viewMedia: { type: Object }, // 팝업에서 보여지고 있는 미디어
    },
    // created(){
    //     console.log(this.media);
    // }
    methods: {
        selectedMediaOpenMethod(media) {
            // console.log(media);
            if (media.media_type_name == 'VR' || media.media_type_name == '문서' || media.media_type_name == '링크' || media.media_type_name == '웹툰') {
                window.open(media.media_path, '_blank').focus();
            } else {
                this.$emit('select-media', media);
            }
        }
    }
}
</script>